"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Map: function() {
        return Map;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const Map = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M14.4453 2.16778C14.7605 1.95768 15.1673 1.94367 15.4961 2.13159L22.4961 6.13159C22.8077 6.30963 23 6.64098 23 6.99983V20.9998C23 21.3563 22.8102 21.6858 22.5019 21.8647C22.1936 22.0437 21.8134 22.0449 21.5039 21.8681L15.0405 18.1747L9.5547 21.8319C9.23954 22.042 8.83273 22.056 8.50386 21.8681L1.50386 17.8681C1.19229 17.69 1 17.3587 1 16.9998V2.99983C1 2.64336 1.18976 2.31385 1.49807 2.13492C1.80639 1.956 2.18664 1.95473 2.49614 2.13159L8.95954 5.82496L14.4453 2.16778ZM8 7.58016L3 4.72301V16.4195L8 19.2767V7.58016ZM10 19.1313L14 16.4646V4.86835L10 7.53502V19.1313ZM16 4.72301V16.4195L21 19.2767V7.58016L16 4.72301Z",
        fill: "currentColor"
    })
}), "Map");
const _default = Map;
